module.exports = __webpack_public_path__ + "img/0Q3C0560_Foamcore.8337c147.jpg";